import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { FAQS } from "./data";

export const Faq = () => (
  <section id="faq" className="relative py-28 sm:py-40 bg-[#FCFBF7]" data-testid="faq-section">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-4">
        <SectionHead eyebrow="Domande frequenti" lines={["Le risposte", "che cercavi."]} />
      </div>
      <Reveal className="lg:col-span-7 lg:col-start-6" delay={0.1}>
        <Accordion type="single" collapsible className="border-t border-[#1B3B28]/15" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#1B3B28]/15">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="f-serif text-2xl sm:text-3xl text-left text-[#1B3B28] py-7 hover:no-underline hover:text-[#3E6B48] transition-colors"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#526356] leading-relaxed pb-7 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
